<template>
    <el-dialog 
        class="mutex-settings" 
        :visible.sync="dialogVisible" 
        :close-on-click-modal="false" 
        :close-on-press-escape="false" 
        :modal-append-to-body="false"
    >
        <div slot="title">
            {{$t('main.AdvancedScripting')}}
            <i 
                class="el-icon-question" 
                style=" color: #ccc; cursor: pointer;" 
                @click="helpDialogVisible = true"
            ></i>
        </div>
        <div class="dialog-body">
            <el-input
                type="textarea"
                :rows="8"
                resize="none"
                :placeholder="$t('main.Enter')"
                v-model="content">
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancel">{{$t('main.cancel2')}}</el-button>
            <el-button size="small" type="primary" @click="submit">{{$t('main.ok2')}}</el-button>
        </span>
        <el-dialog 
            class="help" 
            :title="$t('main.Help')"
            :visible.sync="helpDialogVisible" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            append-to-body
        >
        <div class="tips-box">
            <div v-for="(item, index) in helpList" :key="index">
                <p class="title"><strong>{{item.title}}</strong></p>
                <p class="list" v-for="(val, i) in item.list" :key="i + 'list'">
                    <template v-if="val.childen">
                        <span v-if="val.num">{{i + 1}}、</span>{{val.title}}
                        <template v-for="(info, index) in val.childen">
                            <p class="list" style="padding-left: 20px;" :key="index">{{index + 1}}、{{info}}</p>
                        </template>
                    </template>
                    <template v-else>
                        <span v-if="val.num">{{i + 1}}、</span>{{val}}
                    </template>
                </p>
            </div>
        </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
export default {
    name: 'AdvancedScript', // 高级脚本
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            dialogVisible: false,
            helpDialogVisible: false,
            content: '',
            helpList: [
                {
                    title: this.$t('main.GiveAnExample'),
                    list: [
                        '[Q1==2]?MatrixRowShow[Q2:2]!MatrixRowHide[Q2:2]',
                        '[Q2_2==2]?MatrixRowShow[Q3:2]!MatrixRowHide[Q3:2]'
                    ],
                    num: false
                },
                {
                    title: `${this.$t('AdvancedScript.ConditionalFunctionsAndUsage')}：`,
                    list: [
                        {
                            title: `${this.$t('AdvancedScript.Normal')}：`,
                            childen: [
                                `[quesCode==optionNum] ${this.$t('AdvancedScript.Normal1')}`,
                                `[quesCode>1] ${this.$t('AdvancedScript.Normal2')}`,
                                `[quesCode_rowsNum==optionNum] ${this.$t('AdvancedScript.Normal3')}`,
                                `[quesCode_rowsNum_optionNum>2] ${this.$t('AdvancedScript.Normal4')}`,
                                `[quesCode_rowsNum_optionNum==123] ${this.$t('AdvancedScript.Normal5')}`,
                            ]
                        },
                        {
                            title: `Exist${this.$t('AdvancedScript.Function')}：`,
                            childen: [
                                `Exist[quesCode:num:optionNums] ${this.$t('AdvancedScript.Exist1')}`,
                                `Exist[quesCode_rowsNum:num:optionNums] ${this.$t('AdvancedScript.Exist2')}`,
                            ]
                        },
                        {
                            title: `!Exist${this.$t('AdvancedScript.Function')}：`,
                            childen: [
                                `!Exist[quesCode:num:optionNums] ${this.$t('AdvancedScript.Exist3')}`,
                                `!Exist[quesCode_rowsNum:num:optionNums] ${this.$t('AdvancedScript.Exist4')}`,
                            ]
                        },
                        {
                            title: `Include${this.$t('AdvancedScript.Function')}：`,
                            childen: [
                                `Include[quesCode:optionNums] ${this.$t('AdvancedScript.Include1')}`,
                                `Include[quesCode_rowsNum:optionNums] ${this.$t('AdvancedScript.Include2')}`,
                            ]
                        },
                        {
                            title: '矩阵组合计算函数',
                            childen: [
                                `MatrixSum[quesCode_rowsNum_optionNum = rowsNum1_optionNum1,rowsNum4_optionNum1] 组合矩阵 计算rowsNum1_optionNum1加rowsNum4_optionNum1单选选中的个数填入到quesCode_rowsNum_optionNum中`,
                                `MatrixSum[quesCode_rowsNum_optionNum = rowsNum1_optionNum1:rowsNum4_optionNum1] 组合矩阵 计算rowsNum1_optionNum1至rowsNum4_optionNum1单选选中的个数填入到quesCode_rowsNum_optionNum中`,
                                `MatrixSum[quesCode_rowsNum_optionNum = rowsNum1_optionNum1,rowsNum3_optionNum1:rowsNum4_optionNum1] 组合矩阵 计算rowsNum1_optionNum1加rowsNum3_optionNum1至rowsNum4_optionNum1单选选中的个数填入到quesCode_rowsNum_optionNum中`,
                                `MatrixD-value[quesCode_rowsNum_optionNum = D-value(rowsNum5_optionNum1, rowsNum5_optionNum2){line}] 组合矩阵 计算rowsNum5_optionNum1, rowsNum5_optionNum2的差值并拼接line列名填入到quesCode_rowsNum_optionNum中`,
                            ]
                        },
                        {
                            title: `IsShow${this.$t('AdvancedScript.Function')}：IsShow[quesCode] ${this.$t('AdvancedScript.IsShow')}`,
                            childen: []
                        },
                        {
                            title: `!IsShow${this.$t('AdvancedScript.Function')}：!IsShow[quesCode] ${this.$t('AdvancedScript.IsHide')}`,
                            childen: []
                        },
                        {
                            title: `IsAnswered${this.$t('AdvancedScript.Function')}：IsAnswered[quesCodes] ${this.$t('AdvancedScript.IsAnswered')}`,
                            childen: []
                        },
                        {
                            title: 'Count函数：',
                            childen: [
                                'Count[quesCode == 2] 多选选项合计选择个数等于2',
                                'Count[quesCode_rowsNum > 2] 矩阵行多选选项合计选择个数大于2',
                            ]
                        },
                        {
                            title: 'Exclude（不包含）：',
                            childen: [
                                'Exclude[quesCode:optionNums] 多选不包含选项',
                                'Exclude[quesCode_rowsNum:optionNums] 矩阵多选不包含选项',
                            ]
                        },
                        {
                            title: 'Order（排序）：',
                            childen: [
                                'Order[quesCode:num1:num2] 排序题(quesCode)中指定选项(num2)排在指定位置(num1)',
                            ]
                        },
                        {
                            title: 'OrderNot（排序非）：',
                            childen: [
                                'Order[quesCode:num1:num2] 排序题(quesCode)中指定选项(num2)不排在指定位置(num1)',
                            ]
                        },
                        {
                            title: 'OrderExist（排序存在）:',
                            childen: [
                                'Order[quesCode:num1:nums] 排序题(quesCode)中指定选项组(num1)任意一项排在指定位置(nums)',
                            ]
                        },
                        {
                            title: 'OrderInexistence（排序不存在）',
                            childen: [
                                'OrderInexistence[quesCode:num1:nums] 排序题(quesCode)中指定选项组(num1)任意一项不排在指定位置(nums)',
                            ]
                        },
                        {
                            title: 'Length（长度）：',
                            childen: [
                                'Length[quesCode > num] 计算各填空题的答案长度是否大于num',
                                'Length[quesCode:optionNum > num] 计算多项填空的第optionNum个的答案长度是否大于num',
                            ]
                        },
                    ],
                    num: true
                },
                {
                    title: `${this.$t('AdvancedScript.Help')}：`,
                    list: [
                        `MatrixRowShow[quesCode:rowsNums]  ${this.$t('AdvancedScript.Help1')}`,
                        `MatrixRowHide[quesCode:rowsNums]  ${this.$t('AdvancedScript.Help2')}`,
                        `QuesShow[quesCode] ${this.$t('AdvancedScript.Help3')}`,
                        `QuesHide[quesCode] ${this.$t('AdvancedScript.Help4')}`,
                        `SetAnswer[quesCode:optionNum]  ${this.$t('AdvancedScript.Help5')}`,
                        `JumpTo[quesCode]  ${this.$t('AdvancedScript.Help6')}`,
                        `RecoverJumpTo[quesCode]  ${this.$t('AdvancedScript.Help7')}`,
                        'IsMust[quesCodes]  该题必答',
                        'IsNotMust[quesCodes]  该题非必答',
                        'HideOption[quesCode:optionNums]  隐藏quesCode题的optionNums选项',
                        'ShowOption[quesCode:optionNums]  显示quesCode题的optionNums选项',
                    ],
                    num: true
                },
                
                {
                    title: `${this.$t('AdvancedScript.Illustrate')}：`,
                    list: [
                        `quesCode：${this.$t('AdvancedScript.Illustrate1')}`,
                        `rowsNum：${this.$t('AdvancedScript.Illustrate2')}`,
                        `optionNum：${this.$t('AdvancedScript.Illustrate3')}`,
                        `num：${this.$t('AdvancedScript.Illustrate4')}`,
                        'nums：选中选项组，例如：1,2,3',
                        '&& 并且',
                        '|| 或者',
                    ],
                    num: true
                }
            ]
        }
    },
	watch:{
        activeQuestion:{
            handler(newV) {
                this.content = this.activeQuestion.advancedScript ? this.activeQuestion.advancedScript : ''
            },
            deep: true,
            immediate: true
        }
	},
    created() {
    },
    methods: {
        // 父级调用(初始化)
        toSetMatrixRows() {
            this.init()
            this.dialogVisible = true
        },
        init() {
        },
        cancel() {
            this.dialogVisible = false
            this.$emit('timer')
            // this.$set(this.activeQuestion, 'advancedScript', '')
        },
        submit() {

            // console.log(this.content)
            if (!this.activeQuestion.advancedScript){
                this.$set(this.activeQuestion, 'advancedScript', '')
            }
            this.activeQuestion.advancedScript = this.content
            this.dialogVisible = false
            this.$emit('timer')
        }
    }
}
</script>
<style scoped lang="scss">
	.labelClass{
		display: flex;
		align-items: center;
	}
    .and{
        display: inline-block;
        margin: 0 10px;
    }
	.labelClass+.labelClass{
        margin-top: 10px;
    }
	.icon{
		cursor: pointer;
	}
    /deep/.el-select .el-tag{
        max-width: 74%;
    }
    .mutex-settings {
        
        /deep/.el-dialog{
            width: 900px;
        }
    }
    /deep/.el-dialog{
        width: 700px;
    }
    .dialog-body{
        padding: 20px 20px 10px;
    }
    .help{
        
        .title, .list{
            margin-top: 10px;
        }
    }
    .tips-box{
        height: calc(100vh - 50vh);
        min-height: 500px;
        overflow: overlay;
    }
</style>